export default [{
    path: '/scalema-external-query',
    component: () =>
        import ('source/pages/scalema/ScalemaBoardEmptyState.vue'),
    name: 'scalema-new-external-query',
    meta: {
        title: 'Scalema',
    }
}, {
    path: '/solutions-generator',
    name: 'scalema-solutions-generator-page-external',
    component: () =>
        import ('source/pages/scalema/ScalemaExternalPage.vue'),
    props: true,
    meta: {
        title: 'Solutions Generator Page - Scalema',
        isCompanyIndependent: true,
        canDisplayGlobalModals: false,
    }
}];
